import identity from "lodash/fp/identity";

class RoutePlanningPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    return identity(data);
  }
}

export default RoutePlanningPageTransform;



// WEBPACK FOOTER //
// ./src/pages/routePlanning/routePlanning.transforms.js